<div class="pa-message-content pa-message-content-file">

    <div class="pa-file-container">
        <img [src]="message.data.files[0].data" class="pa-file-message">
        <div *ngIf="message.data.files.length > 1 || message.data.isUploading" class="pa-file-message-overlay"></div>
        <span *ngIf="message.data.files.length > 1 && !message.data.isUploading  && !message.data.isError"
              class="pa-file-message-count">{{message.data.files.length}}</span>
        <div *ngIf="message.data.isUploading && !message.data.isError" class="pa-file-message-upload-indicator"></div>
        <div *ngIf="message.data.isError" class="pa-file-message-error"></div>
    </div>

</div>

